var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMoreUserProgress = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#DADADA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.8333V1.83331L22 6.83331L12 11.8333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21.0833C4.47 21.5433 2 22.6033 2 23.8333C2 25.4933 6.48 26.8333 12 26.8333C17.52 26.8333 22 25.4933 22 23.8333C22 22.6033 19.53 21.5433 16 21.0833"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMoreUserProgress, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_More_User_Progress.7daf4e4c.svg";
export { ForwardRef as ReactComponent };